import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { SalesAcumulatedDashboardContainerProps } from "../../../../interfaces/containers";
import SalesAcumulated from "../../../../pages/Profile/Dashboard/SalesAcumulated";
import { getSalesPeriod, cleanSalesAcumulated } from "../../../../actions/dashboard";

function mapStateToProps(state: SalesAcumulatedDashboardContainerProps) {
    return {
        user: state.auth.user,
        branch: state.profile.dashboard.branch,
        salesAcumulated: state.profile.dashboard.salesAcumulated
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getSalesPeriod,
        cleanSalesAcumulated
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesAcumulated);